/*
import notErrorReporter from 'not-error/src/reporter.browser.mjs';
import notError from 'not-error/src/error.browser.mjs';

const reporter = new notErrorReporter({
    key: '',
    origin: {host: location.origin},
    url: '_ROLLUP_REPORTER_URL_',
    registerAll: true
});
*/
class Reporter {
    static report(e) {
        console.error(e);
        //        reporter.report(e).catch(console.error);
    }
    static reportError(name, opts, e) {
        console.error(name, opts, e);
        //reporter.reportError(name, opts, e, false).catch(console.error);
    }
}
export default Reporter;
